module.exports = __webpack_public_path__ + "static/media/participants_list_4.bdb9798d.pdf";